<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> {{ otaEdit ? 'Edit' : otaView ? 'View' :
        'Add' }}
        OTA App</div>
    <!-- <ngx-loading [show]="loading"></ngx-loading> -->
    <form [formGroup]="otaForm" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>App</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="app">
                        <mat-option (onSelectionChange)="changeDevice($event)"
                            *ngFor="let item of appList; let i = index" [value]="item.app" selected>
                            {{item.app | titlecase}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="formSubmitted && formValues['app'].errors">
                        <mat-error *ngIf="formValues['app'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>App is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="modal-form d-flex">
                <mat-form-field class="field">
                    <mat-label>Device Model</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="deviceModel">
                        <mat-option *ngFor="let item of deviceModels; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="formSubmitted && formValues['deviceModel'].errors">
                        <mat-error *ngIf="formValues['deviceModel'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Device Model is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="modal-form d-flex">
                <mat-form-field class="field">
                    <mat-label>App Type</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="appType">
                        <mat-option *ngFor="let item of appTypeList; let i = index" [value]="item.value" selected>
                            {{item.value | titlecase}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="formSubmitted && formValues['appType'].errors">
                        <mat-error *ngIf="formValues['appType'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>App Type is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Stable Version</mat-label>
                    <input matInput formControlName="stableVersion">
                    <ng-container *ngIf="formSubmitted && formValues['stableVersion'].errors">
                        <mat-error *ngIf="formValues['stableVersion'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Stable Version is required
                        </mat-error>
                        <mat-error *ngIf="formValues['stableVersion'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Latest Version</mat-label>
                    <input matInput formControlName="latestVersion">
                    <ng-container *ngIf="formSubmitted && formValues['latestVersion'].errors">
                        <mat-error *ngIf="formValues['latestVersion'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Latest Version is required
                        </mat-error>
                        <mat-error *ngIf="formValues['latestVersion'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="modal-form m-2">
                <div class="form-group">
                    <button mat-raised-button color="primary" [disabled]="fileLoader" *ngIf="fileURL==null && !otaView"
                        (click)="fileInput.value=''; fileInput.click()">{{buttonText}}
                        <span *ngIf="fileLoader" class="spinner-border spinner-border-sm mr-1"></span>
                    </button>
                    <button mat-raised-button color="primary" [disabled]="fileLoader" *ngIf="fileURL !=null && !otaView"
                        (click)="deleteFile()"><span *ngIf="fileLoader"
                            class="spinner-border spinner-border-sm mr-1"></span>{{buttonText}}
                    </button>
                    <span class="file-info" *ngIf="!otaView">{{ fileInfo }}</span>
                    <input type="file" #fileInput (change)="onFileSelect($event)" style="display:none;" />
                    <div *ngIf="(formSubmitted||modalClose) && !checkApiCall && fileURL==null" class="err-mssg ml-4 mt-2">
                        <div *ngIf="errorMessage"> <em class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}
                        </div>
                    </div>
                    <div *ngIf="(formSubmitted||modalClose) && !checkApiCall && fileURL !=null" class="err-mssg ml-4 mt-2">
                        <div *ngIf="errorMessg"> <em class="fas fa-exclamation-circle mr-2"></em>{{errorMessg}}</div>
                    </div>
                    <div class="err-mssg ml-4 mt-2" *ngIf="fileValidationError"> <em
                            class="fas fa-exclamation-circle mr-2"></em>{{fileValidationError}}</div>
                </div>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>File Name</mat-label>
                    <input matInput formControlName="fileName">
                    <ng-container *ngIf="formSubmitted && formValues['fileName'].errors">
                        <mat-error *ngIf="formValues['fileName'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>File Name is required
                        </mat-error>
                        <mat-error *ngIf="formValues['fileName'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>File Size</mat-label>
                    <input matInput formControlName="fileSize">
                    <ng-container *ngIf="formSubmitted && formValues['fileSize'].errors">
                        <mat-error *ngIf="formValues['fileSize'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>File Size is required
                        </mat-error>
                        <mat-error *ngIf="formValues['fileSize'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Url</mat-label>
                    <input matInput formControlName="url">
                    <ng-container *ngIf="formSubmitted && formValues['url'].errors">
                        <mat-error *ngIf="formValues['url'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Url is required
                        </mat-error>
                        <mat-error *ngIf="formValues['url'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                            </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
        </div>
        
        <div class="modal-form m-2"  *ngIf="fileURL !=null && otaView">
            <div class="text-center">
                <label class="ft-12 mr-4">Click to download</label>
                <div class="d-flex align-items-center h-100 justify-content-center flex-column">
                <div class="download_Icon">
                    <span class="fas fa-download cursor ft-30 mr-4" title="Download File" (click)="downloadFile()"></span>
                    <em class="fa-solid fa-arrow-down-to-bracket"></em>
                </div>
                </div>
            </div>
            <div class="text-center">
                <label class="ft-12 mr-4">Scan to download</label>
                <qrcode [qrdata]="myAngularxQrCode" [width]="200"  [errorCorrectionLevel]="'M'"></qrcode>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessages"><em
                    class="fas fa-exclamation-circle mr-2"></em>{{errorMessages}}</div>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button *ngIf="!otaView" mat-raised-button color="primary" type="submit"
            (click)="onSubmit()">
                {{ otaEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
</div>